import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@codex/themes';
import detectVariants from '@dc/fo-experiment/lib/detectVariants';
import uiLocale from '../utils/UILocale.js';
import uiSettings from '../utils/UISettings';
import PSAPopup, { PSA_SWITCHED_OFF }
  from '../components/react/PopupStyleAttach/components/PSAPopup/PSAPopup';

const React = require('react');
const ReactDOM = require('react-dom');

export const initPSAPopup = (
  psaVariantFromSwitch,
  recycleAndInstallEnabled,
  psaWhenBoughtWithEnabled
) => {
  const PSAPopupWrapper = document.querySelector('[data-component="psa-popup"]');

  // read configuration from AB tests
  const experimentsConfiguration = typeof window !== 'undefined' ? {
    ...window.EXPT_CONFIG,
    QUERY: window.location.search
  } : {};
  const psaVariantMainFromExptConfig = detectVariants('psa-main', experimentsConfiguration);
  const psaVariantMcdFromExptConfig = detectVariants('psa-mcd', experimentsConfiguration);
  const psaVariantTradeupFromExptConfig = detectVariants('psa-tradeup', experimentsConfiguration);

  const psaVariant = psaVariantFromSwitch !== PSA_SWITCHED_OFF
    ? psaVariantFromSwitch
    // eslint-disable-next-line max-len
    : psaVariantMainFromExptConfig || psaVariantMcdFromExptConfig || psaVariantTradeupFromExptConfig;

  if (
    psaVariant !== PSA_SWITCHED_OFF &&
    PSAPopupWrapper !== null &&
    window.digitalData.product &&
    window.digitalData.product[0] &&
    window.digitalData.product[0].productID
  ) {
    const isStaticBundle =
      !!(window.digitalData &&
        window.digitalData.product &&
        window.digitalData.product.length &&
        window.digitalData.product[0].subItems &&
        window.digitalData.product[0].subItems.length &&
        window.digitalData.product[0].subItems[0].productID);

    const productID = isStaticBundle
      ? window.digitalData.product[0].subItems[0].productID
      : window.digitalData.product[0].productID;

    let mainProductData;
    let staticBundleSubProducts;
    if (isStaticBundle) {
      mainProductData = {
        productID: window.digitalData.product[0].productID,
        productName: window.digitalData.product[0].productName,
        productManufacturer: window.digitalData.product[0].manufacturer,
        productImgUrl: window.digitalData.product[0].imageUrl,
        productPrice: window.digitalData.product[0].currentPrice
      };
      staticBundleSubProducts = window.digitalData.product[0].subItems.map((subItem) => ({
        productID: subItem.productID,
        productName: subItem.productName,
        segmentId: subItem.category.segmentId
      }));
    }

    // Get translations and settings
    const attachmentsLabel = uiLocale.getString('component.psa.other_customers_bought');
    const continueToBasketButtonLabel =
      uiLocale.getString('component.psa.continue_to_basket_button');
    const continueShoppingButtonLabel =
      uiLocale.getString('component.psa.continue_shopping_button');
    const addAttachmentInBasketLabel =
      uiLocale.getString('component.psa.add_attachment_in_basket_label');
    const addAttachmentInBasketInProgressLabel =
      uiLocale.getString('component.psa.add_attachment_in_basket_in_progress_label');
    const attachmentAddedInBasketLabel =
      uiLocale.getString('component.psa.attachment_added_in_basket_label');
    const basketInfoLabel1 =
      uiLocale.getString('component.psa.basket_info_label');
    const basketInfoLabel2Singular =
      uiLocale.getString('component.psa.basket_info_label_2_singular');
    const basketInfoLabel2Plural =
      uiLocale.getString('component.psa.basket_info_label_2_plural');
    const headerItemLabel =
      uiLocale.getString('component.psa.header_item_label');
    const headerBundleLabel =
      uiLocale.getString('component.psa.header_bundle_label');
    const failedToUpdateBasket = uiLocale.getString('component.psa.failed_to_update_basket') ||
      'Failed to update basket';
    const pleaseTryAgain = uiLocale.getString('component.psa.please_try_again') ||
      'Please try again';
    const addButtonLabel = uiLocale.getString('component.psa.ri.add_service_to_basket');
    const removeButtonLabel = uiLocale.getString('component.psa.ri.remove_service_from_basket');
    const recyclingLabel = uiLocale.getString('component.psa.ri.recycling_label');
    const installationLabel = uiLocale.getString('component.psa.ri.installation_label');
    const recyclingHelpText = uiLocale.getString('component.psa.ri.recycle_help_text');
    const installationHelpText = uiLocale.getString('component.psa.ri.installation_label');
    const weHelpHeadingLabel = uiLocale.getString('component.psa.ri.we_also_help_with');
    const moreInfoLabel = uiLocale.getString('component.psa.ri.more_info_label');
    const storeUrl = uiSettings.get('component.psa.api');

    ReactDOM.render(
      <Provider store={window.appState}>
        <ThemeProvider theme={themes.currys}>
          <PSAPopup
            psaVariant={psaVariant}
            recycleAndInstallEnabled={recycleAndInstallEnabled}
            psaWhenBoughtWithEnabled={psaWhenBoughtWithEnabled}
            productID={productID}
            mainProductData={mainProductData}
            staticBundleSubProducts={staticBundleSubProducts}
            storeUrl={storeUrl}
            attachmentsLabel={attachmentsLabel}
            continueToBasketButtonLabel={continueToBasketButtonLabel}
            continueShoppingButtonLabel={continueShoppingButtonLabel}
            addAttachmentInBasketLabel={addAttachmentInBasketLabel}
            addAttachmentInBasketInProgressLabel={addAttachmentInBasketInProgressLabel}
            attachmentAddedInBasketLabel={attachmentAddedInBasketLabel}
            basketInfoLabel1={basketInfoLabel1}
            basketInfoLabel2Singular={basketInfoLabel2Singular}
            basketInfoLabel2Plural={basketInfoLabel2Plural}
            headerItemLabel={headerItemLabel}
            headerBundleLabel={headerBundleLabel}
            failedToUpdateBasket={failedToUpdateBasket}
            pleaseTryAgain={pleaseTryAgain}
            addButtonLabel={addButtonLabel}
            removeButtonLabel={removeButtonLabel}
            recyclingLabel={recyclingLabel}
            installationLabel={installationLabel}
            recyclingHelpText={recyclingHelpText}
            installationHelpText={installationHelpText}
            weHelpHeadingLabel={weHelpHeadingLabel}
            moreInfoLabel={moreInfoLabel}
          />
        </ThemeProvider>
      </Provider>,
      PSAPopupWrapper
    );
  }
};
